import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Toast from './Toast';
import { default as ToastManager } from '../../../Utility/ToastManager';
import useInheritedTheme from '../../../Hooks//UseInheritedTheme';
export default function ToastContainer() {
    const theme = useInheritedTheme();
    const [toasts, setToasts] = useState([]);
    useEffect(() => {
        ToastManager.registerSetState(setToasts);
    }, []);
    const onClose = (toast) => {
        ToastManager.hideToast(toast);
    };
    return (_jsx(StyledToastContainer, { theme: theme, children: toasts.map((toast) => (_jsx(Toast, { type: toast.type, text: toast.text, autoCloseMs: toast.autoCloseMs, onClose: () => onClose(toast), action: toast.action }, toast.id))) }));
}
const StyledToastContainer = styled.div `
	position: fixed;
	bottom: 0;
	right: 0;
	display: grid;
	z-index: 900;

	${(props) => `
		gap: ${props.theme.spacing.lg};
		margin: ${props.theme.spacing.lg};
	`};
`;
//# sourceMappingURL=ToastContainer.js.map